import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { AppComponent } from './app.component'
import { RouterModule } from '@angular/router'
import { AppRoutingModule } from './app-routing.module'
import { initializeApp, provideFirebaseApp } from '@angular/fire/app'
import { connectFirestoreEmulator, getFirestore, provideFirestore } from '@angular/fire/firestore'
import { environment } from '../environments/environment'
import { portsConfig } from '../environments/ports.config'
import { connectAuthEmulator, getAuth, provideAuth } from '@angular/fire/auth'
import { connectFunctionsEmulator, getFunctions, provideFunctions } from '@angular/fire/functions'
import { connectStorageEmulator, getStorage, provideStorage } from '@angular/fire/storage'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { HttpClientModule } from '@angular/common/http'
import { ToastrModule } from 'ngx-toastr'

import { InvoicesListComponent } from './admin/admin-oages/vat/invoices-list/invoices-list.component'
import { ProformaListComponent } from './admin/admin-oages/vat/proforma-list/proforma-list.component'
import { AdminPagesModule } from './admin/admin-pages/admin-pages.module'
import { CoreModule } from './shared/core/core.module'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

let resolvePersistenceEnabled: (enabled: boolean) => void

export const persistenceEnabled = new Promise<boolean>((resolve) => {
    resolvePersistenceEnabled = resolve
})

@NgModule({
    declarations: [AppComponent, InvoicesListComponent, ProformaListComponent],
    imports: [
        BrowserModule,

        BrowserAnimationsModule,
        RouterModule,
        AppRoutingModule,
        HttpClientModule,
        ToastrModule.forRoot({
            positionClass: 'toast-bottom-right',
            timeOut: 3000,
            progressBar: true,
            progressAnimation: 'decreasing',
            preventDuplicates: true,
            newestOnTop: true,
            maxOpened: 5,
            autoDismiss: true,
        }),
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        // provideFirestore(() => getFirestore()),
        provideFirestore(() => {
            const firestore = getFirestore()
            if (environment.useEmulators) {
                connectFirestoreEmulator(firestore, portsConfig.angular.defaultHost, portsConfig.firebase.firestore)
            }
            // enableMultiTabIndexedDbPersistence(firestore).then(
            //     () => resolvePersistenceEnabled(true),
            //     () => resolvePersistenceEnabled(false)
            // )
            return firestore
        }),
        provideAuth(() => {
            const auth = getAuth()
            if (environment.useEmulators) {
                connectAuthEmulator(auth, portsConfig.urls.authEmulator, { disableWarnings: true })
            }
            return auth
        }),
        provideFunctions(() => {
            const functions = getFunctions()
            if (environment.useEmulators) {
                connectFunctionsEmulator(functions, portsConfig.angular.defaultHost, portsConfig.firebase.functions)
            }
            return functions
        }),
        provideStorage(() => {
            const storage = getStorage()
            if (environment.useEmulators) {
                connectStorageEmulator(storage, portsConfig.angular.defaultHost, portsConfig.firebase.storage)
            }
            return storage
        }),
        AdminPagesModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    providers: [{ provide: 'googleTagManagerId', useValue: environment.googleTagManagerKey }],
    bootstrap: [AppComponent],
    exports: [],
})
export class AppModule {}

